import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconQuotas from './nav-icon-quotas.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconQuotas {...validProps} />;
}
SvgComponent.iconName = 'navIconQuotas';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconQuotasIcon = svgIconWrapper(SvgComponent);
